import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import classNames from 'classnames';


import moment from 'moment';
import momentDF from 'moment-duration-format';

import {Icon} from 'react-fa';


class RealTimeDepartures extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    renderTime = (value) => {
        const {time, timeString} = this.props;

        let display = "";

        if (this.props.fromNow) {
            display = value.fromNow();
        } else {
            if (value.isBefore()) {
                return null;
            }

            const diff = time.diff(value);
            const duration = moment.duration(diff);
            const {hours, minutes, seconds} = duration._data;

            const remainingMinutes = Math.abs(hours) * 60 + Math.abs(minutes);

            if (remainingMinutes < 1) {
                display = (seconds > -30) ? "kohe" : "< 1 min";
            } else if (remainingMinutes < 59) {
                const formattedDuration = Math.abs(parseInt(duration.format("m"), 10));
                display = `${formattedDuration} min`;
            } else {
                display = value.format("H:mm");
            }
        }

        return (<time dateTime={timeString} title={value.format("HH:mm")}>{display}</time>);
    };

    render() {
        const {departure, route, stop} = this.props;

        return (
            <Link className="route" to={`/timetable/${route.route_id}/${stop.stop_id}/`}>
                <span
                    className={classNames("route__number", `route__type-${route.route_type}`)}
                    title={`${route.route_short_name} ${departure.destination}`}
                >
                    {route.route_short_name}
                </span>
                <span className="route__destination">{departure.destination}</span>
                <span className="route__departure">
                    {departure.live ? (
                        <Icon name="circle" className="route__departure__realtime" title="Reaalajas"/>
                    ) : null}
                        {departure.departure ? this.renderTime(departure.departure) : null}
                </span>
            </Link>
        );
    }
}

RealTimeDepartures.propTypes = {};

export default RealTimeDepartures;



// WEBPACK FOOTER //
// ./src/components/RealTimeDepartures.js